<div class="modal-header">
  <h4 class="modal-title me-3">{{ title | translate }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (description) {
    <p>{{ description | translate }}</p>
  }
  @if (documentationLink) {
    <span style="margin-top: -1rem; margin-bottom: 0.25rem">
      <a [href]="documentationLink" target="_blank">
        <span class="material-symbols-outlined">menu_book</span>
        &nbsp;
        <span>{{ 'dataconnection.docs' | translate }}</span>
      </a>
    </span>
  }
  <ngx-monaco-editor
    class="full-size"
    #editor
    [options]="editorOptions"
    [(ngModel)]="code"
  ></ngx-monaco-editor>
</div>
<div class="modal-footer">
  <div class="form-check me-auto ms-2">
    <input #lineWrap class="form-check-input" type="checkbox" value="1" />
    <label class="form-check-label">
      {{ 'workflow.line_wrap' | translate }}
    </label>
  </div>
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    {{ buttonText | translate }}
  </button>
</div>
